
import React, {Component} from 'react'
import {Modal,ButtonToolbar,Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import {Radio,RadioGroup} from 'react-icheck'
import WorkdocStore from '../../stores/WorkdocStore'

class NewDocFormModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:[],loading:false,newDoc:true,filterType:'all',priceOnListType:'showprice',docName:'',docType:'',workNo:''}
  }

  loadData(props){
    this.setState(Object.assign({loading:true,show:true},props))
    let that = this
    WorkdocStore.loadDocRecord(props.workNo,props.docType,function(result){
      if(result.data.length>0)
        that.setState({loading:false,data:result.data,newDoc:false})
      else
        that.setState({loading:false,data:[],newDoc:true})
    },function(){
      that.setState({loading:false,newDoc:true,data:[]})
    })
  }

  onConfirmClick(){
    let {filterType,priceOnListType,onNewDoc} = this.state
    // console.log('confirm',filterType,priceOnListType)
    if(onNewDoc !==undefined){
      this.state.onNewDoc(filterType,priceOnListType)
    }
    this.onHide()
  }

  onNewClick(){
    this.setState({newDoc:true})
  }

  onRowClick(item){
    let {onRowClick} = this.state
    if(onRowClick !==undefined){
      this.state.onRowClick(item.invoice_no)
    }
    this.onHide()
  }

  onFilterRadioChange(e,value){
    
    this.setState({filterType:value})
  }

  onPriceRadioChange(e,value){
    this.setState({priceOnListType:value})
  }

  onHide(){
    this.setState({show:false})
  }

  renderTableData(){
    let {data} = this.state

    return data.map((item,index)=>{
      return (<tr key={index} onClick={this.onRowClick.bind(this,item)}>
        <td>{item.invoice_date}</td>
        <td>{item.invoice_no}</td>
        <td>{item.amount}</td>
        <td>{item.remark}</td>
      </tr>)
    })
  }

  renderTable(){
    return (
      <table className="table table-responsive table-bordered-solid table-hover">
      <thead>
          <tr>              
              <th>วันที่</th>
              <th>เอกสารเลขที่</th>                                            
              <th>มูลค่า</th> 
              <th>หมายเหตุ</th>
          </tr>
      </thead>
      <tbody>
          {this.renderTableData()}
      </tbody>
      <tfoot>
          <tr>              
              <th>วันที่</th>
              <th>เอกสารเลขที่</th>                                            
              <th>มูลค่า</th> 
              <th>หมายเหตุ</th>
          </tr>
      </tfoot>
  </table>
    )
  }

  renderNewDocOption(){
    let {docName,workNo,filterType,priceOnListType} = this.state   
    let message = 'ต้องการสร้างเอกสาร '+docName+' จากใบงาน '+workNo
    return (<div>
      <div>{message}</div><br/>
      <div>ทำการออกรายการ</div>
      <RadioGroup name="radio" value={filterType} onChange={this.onFilterRadioChange.bind(this)}>
        <Radio
          value="all"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' ค่าแรงและค่าอะไหล่'}
        />
        <Radio
          value="wage"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' ค่าแรงอย่างเดียว'}
        />
        <Radio
          value="part"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' ค่าอะไหล่อย่างเดียว'}          
        />
      </RadioGroup>
      <div>แสดงราคา</div>
      <RadioGroup name="radio" value={priceOnListType} onChange={this.onPriceRadioChange.bind(this)}>
        <Radio
          value="showprice"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' แสดงราคาในรายการ'}
        />
        <Radio
          value="showsummary"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' ไม่แสดงราคา มีรายการรวบยอดให้'}
        />
       
      </RadioGroup>
    </div>)
  }

  renderBody(){
    let {loading,newDoc} = this.state
    if(loading){
      return (<div>กำลังดึงข้อมูล...</div>)
    }

    if(newDoc){
      return this.renderNewDocOption()
    }else{
      return this.renderTable()
    }
  }

  render(){
    let {show,newDoc,loading} = this.state
    let title = newDoc?'ยืนยันการทำรายการ ':'พบรายการเอกสารที่เคยสร้าง เปิดดูเอกสารด้วยการคลิ๊กบนแถว หรือสร้างเอกสารใหม่'
    if(loading){
      title = '...'
    }
    return (
      <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{title} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {this.renderBody()}
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button style={{display:newDoc?'none':'block'}} bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name='file-text-o'/>&nbsp;สร้างเอกสารใหม่</Button>
            <Button style={{display:newDoc?'block':'none'}} bsStyle={'primary'} onClick={this.onConfirmClick.bind(this)}><FontAwesome name='file-text-o'/>&nbsp;ตกลง</Button>
            <Button onClick={this.onHide.bind(this)}><FontAwesome name='close'/>&nbsp;ปิด</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default NewDocFormModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/NewDocFormModal.js